export const matchElementHeight = (elements, enableMobile, resetMobile) => {
    var windowWidth = window.innerWidth,
        elementsToSize = $(elements),
        elementsHeights = [],
        mobileOption = (enableMobile == undefined || enableMobile !== true) ? false : true,
        disableMobile = mobileOption || windowWidth >= 768,
        undoForMobile = (resetMobile == undefined || resetMobile !== false) ? true : false;
    if (elementsToSize.length > 1 && disableMobile) {
        elementsToSize.css('height', '');
        $.each(elementsToSize, function() {
            elementsHeights.push($(this).outerHeight());
        });
        (resetMobile && windowWidth < 768) ? $(elements).css('height', ''): $(elements).css('height', Math.max.apply(Math, elementsHeights));
    }
};
